// Datos fake para Fase 1 del Localizador de Servicios

export const perfiles = [
  { id: 'max', nombre: 'Max', tipo: 'mascota', subtipo: 'Perro' },
  { id: 'luna', nombre: 'Luna', tipo: 'mascota', subtipo: 'Gato' },
  { id: 'llaves', nombre: 'Llaves Casa', tipo: 'objeto' },
  { id: 'mochila', nombre: 'Mochila', tipo: 'objeto' }
];

export const categoriasMascota = {
  establecimientos: [
    { id: 'veterinaria', nombre: 'Veterinaria', icono: 'medical' },
    { id: 'farmacia', nombre: 'Farmacia', icono: 'pharmacy' },
    { id: 'parques', nombre: 'Parques', icono: 'park' },
    { id: 'pension', nombre: 'Pensión', icono: 'house' },
    { id: 'estilistas-est', nombre: 'Estilistas', icono: 'scissors' }
  ],
  proveedores: [
    { id: 'paseadores', nombre: 'Paseadores', icono: 'walk' },
    { id: 'entrenadores', nombre: 'Entrenadores', icono: 'training' },
    { id: 'cuidadores', nombre: 'Cuidadores', icono: 'care' },
    { id: 'estilistas-ind', nombre: 'Estilistas', icono: 'scissors' }
  ]
};

export const categoriasObjeto = {
  establecimientos: [
    { id: 'cerrajeria', nombre: 'Cerrajería', icono: 'key' },
    { id: 'farmacia-24h', nombre: 'Farmacia 24h', icono: 'pharmacy' },
    { id: 'conveniencia', nombre: 'Conveniencia', icono: 'store' },
    { id: 'mecanico', nombre: 'Mecánico / Automotriz', icono: 'wrench' }
  ]
};

export const establecimientos = [
  {
    id: 'vet-roma',
    nombre: 'Hospital Veterinario Roma',
    categoria: 'veterinaria',
    categoriaDisplay: 'Veterinaria',
    tipo: 'establecimiento',
    rating: 4.6,
    resenas: 47,
    distancia: '1.2 km',
    estado: 'abierto',
    estadoTexto: 'Abierto 24h',
    es24h: true,
    direccion: 'Av. Ávila Camacho 123, Centro',
    ciudad: 'Xalapa, Veracruz',
    telefono: '2281234567',
    whatsapp: '2281234567',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia', 'Tarjeta'],
    estacionamiento: '3 lugares propios (gratis)',
    servicios: ['Consulta', 'Urgencias', 'Cirugía', 'Rayos X', 'Hospitalización', 'Vacunación'],
    lat: 19.5438,
    lng: -96.9102
  },
  {
    id: 'vet-san-jose',
    nombre: 'Veterinaria San José',
    categoria: 'veterinaria',
    categoriaDisplay: 'Veterinaria',
    tipo: 'establecimiento',
    rating: 4.2,
    resenas: 23,
    distancia: '2.1 km',
    estado: 'abierto',
    estadoTexto: 'Abierto',
    es24h: false,
    direccion: 'Calle Juárez 456',
    ciudad: 'Xalapa, Veracruz',
    telefono: '2289876543',
    whatsapp: '2289876543',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia'],
    estacionamiento: 'En la calle (fácil)',
    servicios: ['Consulta', 'Vacunación', 'Estética'],
    lat: 19.5305,
    lng: -96.9180
  },
  {
    id: 'pet-house',
    nombre: 'Clínica Pet House',
    categoria: 'veterinaria',
    categoriaDisplay: 'Veterinaria',
    tipo: 'establecimiento',
    rating: 3.9,
    resenas: 15,
    distancia: '3.4 km',
    estado: 'cerrado',
    estadoTexto: 'Cerrado',
    horarioAbre: 'Abre 9:00',
    es24h: false,
    direccion: 'Plaza Crystal Local 12',
    ciudad: 'Xalapa, Veracruz',
    telefono: '2285551234',
    whatsapp: null,
    foto: null,
    metodosPago: ['Efectivo'],
    estacionamiento: 'Plaza Crystal (con consumo)',
    servicios: ['Consulta', 'Vacunación'],
    lat: 19.5201,
    lng: -96.8950
  },
  {
    id: 'cerrajeria-express',
    nombre: 'Cerrajería Express 24h',
    categoria: 'cerrajeria',
    categoriaDisplay: 'Cerrajería',
    tipo: 'establecimiento',
    rating: 4.4,
    resenas: 31,
    distancia: '0.8 km',
    estado: 'abierto',
    estadoTexto: 'Abierto 24h',
    es24h: true,
    direccion: 'Av. Xalapa 789',
    ciudad: 'Xalapa, Veracruz',
    telefono: '2281112233',
    whatsapp: '2281112233',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia', 'Tarjeta'],
    estacionamiento: 'En la calle',
    servicios: ['Apertura casas', 'Apertura autos', 'Copia de llaves', 'Servicio a domicilio'],
    lat: 19.5410,
    lng: -96.9050
  },
  {
    id: 'farmacia-gdl',
    nombre: 'Farmacia Guadalajara Ánimas',
    categoria: 'farmacia-24h',
    categoriaDisplay: 'Farmacia 24h',
    tipo: 'establecimiento',
    rating: 4.1,
    resenas: 89,
    distancia: '0.5 km',
    estado: 'abierto',
    estadoTexto: 'Abierto 24h',
    es24h: true,
    direccion: 'Av. Las Ánimas 234',
    ciudad: 'Xalapa, Veracruz',
    telefono: '2283334455',
    whatsapp: null,
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia', 'Tarjeta'],
    estacionamiento: '10 lugares propios (gratis)',
    servicios: ['Farmacia', 'Productos veterinarios'],
    lat: 19.5480,
    lng: -96.9200
  },
  {
    id: 'parque-juarez',
    nombre: 'Parque Juárez',
    categoria: 'parques',
    categoriaDisplay: 'Parques',
    tipo: 'establecimiento',
    rating: 4.5,
    resenas: 156,
    distancia: '1.5 km',
    estado: 'abierto',
    estadoTexto: 'Abierto',
    es24h: false,
    direccion: 'Centro Histórico',
    ciudad: 'Xalapa, Veracruz',
    telefono: null,
    whatsapp: null,
    foto: null,
    metodosPago: [],
    estacionamiento: 'En la calle',
    servicios: ['Área verde', 'Bancas', 'Zona para mascotas'],
    lat: 19.5295,
    lng: -96.9220
  },
  {
    id: 'pension-canina',
    nombre: 'Pensión Canina Happy Tails',
    categoria: 'pension',
    categoriaDisplay: 'Pensión',
    tipo: 'establecimiento',
    rating: 4.7,
    resenas: 34,
    distancia: '4.2 km',
    estado: 'abierto',
    estadoTexto: 'Abierto',
    es24h: false,
    direccion: 'Carretera Xalapa-Coatepec km 2',
    ciudad: 'Xalapa, Veracruz',
    telefono: '2287778899',
    whatsapp: '2287778899',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia'],
    estacionamiento: '5 lugares propios (gratis)',
    servicios: ['Hospedaje', 'Paseos diarios', 'Alimentación incluida', 'Cámaras 24h'],
    lat: 19.5100,
    lng: -96.9400
  },
  {
    id: 'oxxo-animas',
    nombre: 'OXXO Ánimas',
    categoria: 'conveniencia',
    categoriaDisplay: 'Conveniencia',
    tipo: 'establecimiento',
    rating: 3.8,
    resenas: 45,
    distancia: '0.3 km',
    estado: 'abierto',
    estadoTexto: 'Abierto 24h',
    es24h: true,
    direccion: 'Av. Las Ánimas 100',
    ciudad: 'Xalapa, Veracruz',
    telefono: null,
    whatsapp: null,
    foto: null,
    metodosPago: ['Efectivo', 'Tarjeta'],
    estacionamiento: '2 lugares propios',
    servicios: ['Tienda de conveniencia', 'Cajero automático', 'Servicios'],
    lat: 19.5490,
    lng: -96.9180
  }
];

export const proveedores = [
  {
    id: 'juan-paseador',
    nombre: 'Juan Pérez',
    categoria: 'paseadores',
    categoriaDisplay: 'Paseador',
    tipo: 'independiente',
    rating: 4.8,
    resenas: 12,
    zonas: 'Centro, Ánimas, Jardines de las Ánimas',
    horario: 'Lunes a Sábado 7:00 - 19:00',
    descripcion: 'Paseo individual y grupal',
    telefono: '2281119999',
    whatsapp: '2281119999',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia'],
    servicios: ['Paseo individual', 'Paseo grupal', 'Entrenamiento básico']
  },
  {
    id: 'maria-paseadora',
    nombre: 'María López',
    categoria: 'paseadores',
    categoriaDisplay: 'Paseadora',
    tipo: 'independiente',
    rating: 4.5,
    resenas: 8,
    zonas: 'Todo Xalapa',
    horario: 'Lunes a Domingo 6:00 - 18:00',
    descripcion: 'Paseo y entrenamiento básico',
    telefono: '2282228888',
    whatsapp: '2282228888',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia'],
    servicios: ['Paseo individual', 'Entrenamiento básico', 'Cuidado en casa']
  },
  {
    id: 'carlos-entrenador',
    nombre: 'Carlos Mendoza',
    categoria: 'entrenadores',
    categoriaDisplay: 'Entrenador',
    tipo: 'independiente',
    rating: 4.9,
    resenas: 28,
    zonas: 'Xalapa y zona conurbada',
    horario: 'Lunes a Viernes 8:00 - 18:00',
    descripcion: 'Entrenamiento canino profesional',
    telefono: '2283335555',
    whatsapp: '2283335555',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia', 'Tarjeta'],
    servicios: ['Obediencia básica', 'Obediencia avanzada', 'Corrección de conducta', 'Entrenamiento en casa']
  },
  {
    id: 'ana-cuidadora',
    nombre: 'Ana García',
    categoria: 'cuidadores',
    categoriaDisplay: 'Cuidadora',
    tipo: 'independiente',
    rating: 4.7,
    resenas: 15,
    zonas: 'Ánimas, Jardines, Reserva Territorial',
    horario: 'Disponible según reservación',
    descripcion: 'Cuidado de mascotas en tu casa o la mía',
    telefono: '2284446666',
    whatsapp: '2284446666',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia'],
    servicios: ['Cuidado diurno', 'Cuidado nocturno', 'Hospedaje', 'Medicación']
  },
  {
    id: 'pedro-estilista',
    nombre: 'Pedro Ramírez',
    categoria: 'estilistas-ind',
    categoriaDisplay: 'Estilista',
    tipo: 'independiente',
    rating: 4.6,
    resenas: 22,
    zonas: 'Servicio a domicilio en toda la ciudad',
    horario: 'Lunes a Sábado 9:00 - 17:00',
    descripcion: 'Estética canina y felina a domicilio',
    telefono: '2285557777',
    whatsapp: '2285557777',
    foto: null,
    metodosPago: ['Efectivo', 'Transferencia'],
    servicios: ['Baño', 'Corte', 'Corte de uñas', 'Limpieza de oídos', 'Deslanado']
  }
];

// Favoritos iniciales (simulando datos guardados)
let favoritosData = [
  { perfilId: 'max', lugarId: 'vet-roma' },
  { perfilId: 'max', lugarId: 'vet-san-jose' },
  { perfilId: 'luna', lugarId: 'pet-house' },
  { perfilId: 'llaves', lugarId: 'cerrajeria-express' },
  { perfilId: 'general', lugarId: 'farmacia-gdl' }
];

// Funciones helper para manejar favoritos (en memoria para Fase 1)
export const getFavoritos = () => [...favoritosData];

export const getFavoritosPorPerfil = (perfilId) => {
  return favoritosData.filter(f => f.perfilId === perfilId);
};

export const esFavorito = (perfilId, lugarId) => {
  return favoritosData.some(f => f.perfilId === perfilId && f.lugarId === lugarId);
};

export const toggleFavorito = (perfilId, lugarId) => {
  const existe = esFavorito(perfilId, lugarId);
  if (existe) {
    favoritosData = favoritosData.filter(f => !(f.perfilId === perfilId && f.lugarId === lugarId));
  } else {
    favoritosData = [...favoritosData, { perfilId, lugarId }];
  }
  return !existe; // Retorna nuevo estado
};

export const eliminarFavorito = (perfilId, lugarId) => {
  favoritosData = favoritosData.filter(f => !(f.perfilId === perfilId && f.lugarId === lugarId));
};

// Helper para obtener lugar por ID (establecimiento o proveedor)
export const getLugarById = (id) => {
  return establecimientos.find(e => e.id === id) || proveedores.find(p => p.id === id);
};

// Helper para obtener lugares por categoría
export const getLugaresPorCategoria = (categoriaId) => {
  const estabs = establecimientos.filter(e => e.categoria === categoriaId);
  const provs = proveedores.filter(p => p.categoria === categoriaId);
  return [...estabs, ...provs];
};

// Helper para obtener perfil por ID
export const getPerfilById = (id) => {
  return perfiles.find(p => p.id === id);
};
